import type { Component } from 'svelte'
import * as drivers from '../services/printer-drivers'

type PrinterConfig = {
  model: PrinterModel
  name: string
  icon: Component
  addIcon: Component
}

export const printers: PrinterConfig[] = Object.values(drivers) as PrinterConfig[]
